'use strict';

angular.module('amexReconciliationApp')
  .service('ValidationService',
    function ValidationService($resource,
                               $q,
                               SiteConfigModel) {

      var CURRENCY_REGEX = /^-?\d{0,3}(?:,?\d{3})*(?:\.\d{0,2})?$/;
      var PERCENTAGE_REGEX = /^-?\d+(?:\.\d+)?$/;

      this.isValidCurrencyNumber = function isValidCurrencyNumber(value) {
        return value && value[0] !== ',' && CURRENCY_REGEX.test(value);
      };

      this.isNonZeroNumber = function isNonZeroNumber(value) {
        var number = parseFloat(value);
        return number !== 0;
      };

      this.isValidPercentage = function isValidPercentage(number) {
        return (String(number).match(PERCENTAGE_REGEX) !== null);
      };

      this.validateOppositeSigns = function validateOppositeSigns(transaction, value) {
        var transactionAmount = transaction.amount;
        var deferred = $q.defer();
        var siteConfiguration = SiteConfigModel.siteConfig() || {};

        if (!siteConfiguration.oppositeSignAllocations && differentSign(+transactionAmount, +value)) {
          deferred.reject();
        } else {
          deferred.resolve();
        }

        return deferred.promise;
      };

      function differentSign(number1, number2) {
        return !((number1 < 0 && number2 < 0) || (number1 > 0 && number2 > 0));
      }
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/ValidationService.js
// module id = 656
// module chunks = 0